<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import Info from '$components/info.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { InfoBlockImageStoryblok } from '$types/bloks';

  export let block: InfoBlockImageStoryblok;
</script>

<section class="px-2 py-12 lg:px-8 lg:py-16">
  <div class="container isolate mx-auto" use:storyblokEditable={block}>
    <div class="flex justify-between flex-col lg:flex-row gap-7">
      <div class="w-full lg:w-4/12 flex flex-col px-2 lg:px-0">
        <Info block={block.info[0]} />
      </div>
      <div class="w-full lg:w-7/12 lg:max-h-full lg:min-h-[720px]">
        <CmsImage image={block.image} class="relative z-10 w-full rounded-md object-cover" />
      </div>
    </div>
  </div>
</section>
